import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { deleteAsset } from '../../services';
import { assetsFeatureKey } from '../keys';

export const useDeleteAssetMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { id: string }>({
    async mutationFn({ id }) {
      await deleteAsset({ routeParams: { id } });
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: assetsFeatureKey });
    },
  });
};
